module.exports = __webpack_public_path__ + "img/Weapon_73.1603681f.png";